import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import * as cloneDeep from 'lodash/cloneDeep';
import { SiteModel, SiteStepperModel } from 'src/app/models/index';
import {
  CommonService,
  SiteService,
  SiteStepperService
} from 'src/app/services/index';
import { SiteStepperEnum } from 'src/app/shared';
import { AlertService, Constants } from 'src/app/shared/index';
export interface ReportConfig {
  featureId: string;
  category: string;
  description: string;
  representation: string;
  enabled: boolean;
}
@Component({
  selector: 'app-report-configuration',
  templateUrl: './report-configuration.component.html',
  styleUrls: ['./report-configuration.component.scss']
})
export class ReportConfigurationComponent implements OnInit {
  // @ViewChild(MatPaginator) paginatorMonthly: MatPaginator;
  // @ViewChild(MatPaginator) paginatorDaily: MatPaginator;
  @ViewChild('paginatorMonthly', { read: MatPaginator })
  paginatorMonthly: MatPaginator;
  @ViewChild('paginatorDaily', { read: MatPaginator })
  paginatorDaily: MatPaginator;
  monthlyReportConfigs: MatTableDataSource<ReportConfig>;
  dailyReportConfigs: MatTableDataSource<ReportConfig>;
  monthlyDisplayedColumns = [
    'featureId',
    'category',
    'description',
    'representation',
    'enabled'
  ];
  dailyDisplayedColumns = [
    'featureId',
    'category',
    'description',
    'representation',
    'enabled'
  ];
  siteId: string;
  siteModel: SiteModel;
  origDailyReportConfigs = [];
  origMonthlyReportConfigs = [];
  dailyReConfigs = [];
  monthlyReConfigs = [];
  constructor(
    private alertService: AlertService,
    private siteStepperService: SiteStepperService,
    private siteService: SiteService,
    private changeDetectorRefs: ChangeDetectorRef,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    this.siteStepperService.getStepperSubject().subscribe((data) => {
      if (
        data.selectedIndex === SiteStepperEnum.ReportConfiguration &&
        !this.commonService.isNullOrUndefined(data.siteModel)
      ) {
        this.siteId = data.siteModel.siteId;
        this.siteModel = data.siteModel;
        // this.fakeReports();
        this.getReports();
      }
    });
  }
  fakeReports() {
    const t = this;
    const data = [
      {
        featureId: 'CI',
        category: 'Customer Info',
        description: 'Customer Basic Information',
        representation: 'Table',
        configFor: 'M',
        configProp: 'BaseRO',
        enabled: true,
        rId: '#407:2',
        order: 0
      },
      {
        featureId: 'MS',
        category: 'Monthly Snapshots',
        description:
          'Monthly kWh; Maximum Power consumed & PF value; Minimum PF value',
        representation: 'Table',
        configFor: 'M',
        configProp: 'BaseRO',
        enabled: true,
        rId: '#408:1',
        order: 0
      },
      {
        featureId: 'EnA',
        category: 'Energy',
        description: 'Monthly Sourced Energy Breakup (Sourcewise)',
        representation: 'Pie Chart & Table',
        configFor: 'M',
        configProp: 'Base',
        enabled: true,
        rId: '#734:0',
        order: 0
      },
      {
        featureId: 'EnB',
        category: 'Energy',
        description: 'Monthly Consumed Energy Breakup (Processwise)',
        representation: 'Pie Chart & Table',
        configFor: 'M',
        configProp: 'Base',
        enabled: true,
        rId: '#407:0',
        order: 0
      },
      {
        featureId: 'EnC',
        category: 'Energy',
        description:
          'Trends of Energy consumption for Monthly day shown per day',
        representation: 'Histogram',
        configFor: 'M',
        configProp: 'Customer Specific',
        enabled: false,
        rId: '#408:2',
        order: 0
      },
      {
        featureId: 'NoteA',
        category: 'Notifications',
        description: 'All alerts segregated and shown as per their Category',
        representation: 'Pie Chart',
        configFor: 'M',
        configProp: 'Customer Specific',
        enabled: false,
        rId: '#409:1',
        order: 0
      },
      {
        featureId: 'NoteB',
        category: 'Notifications',
        description: 'All alerts segregated and shown as per their set loads',
        representation: 'Pie Chart',
        configFor: 'M',
        configProp: 'Customer Specific',
        enabled: false,
        rId: '#406:1',
        order: 0
      },
      {
        featureId: 'OnA',
        category: 'ON Time',
        description: 'Daywise ON time(hours) for all loads in the month',
        representation: 'Table',
        configFor: 'M',
        configProp: 'Customer Specific',
        enabled: false,
        rId: '#408:0',
        order: 0
      },
      {
        featureId: 'EnD',
        category: 'Energy',
        description: 'Daywise Energy(kWh) for all loads in the month',
        representation: 'Table',
        configFor: 'M',
        configProp: 'Customer Specific',
        enabled: false,
        rId: '#409:2',
        order: 0
      },
      {
        featureId: 'NoteC',
        category: 'Notifications',
        description:
          'All alerts generated in the month are categorised as per type',
        representation: 'Table',
        configFor: 'M',
        configProp: 'Base',
        enabled: true,
        rId: '#734:1',
        order: 0
      },
      {
        featureId: 'CI',
        category: 'Customer Info',
        description: 'Customer Basic Information',
        representation: 'Table',
        configFor: 'D',
        configProp: 'BaseRO',
        enabled: true,
        rId: '#407:1',
        order: 0
      },
      {
        featureId: 'DS',
        category: 'Daily Snapshots',
        description: 'kWh Consumed; Max Power & PF; Min PF for the day',
        representation: 'Table',
        configFor: 'D',
        configProp: 'BaseRO',
        enabled: true,
        rId: '#409:0',
        order: 0
      },
      {
        featureId: 'ON-En',
        category: 'ON-Energy',
        description: 'Day ON and Energy (Processwise)',
        representation: 'Bar Chart',
        configFor: 'D',
        configProp: 'Base',
        enabled: false,
        rId: '#406:0',
        order: 0
      },
      {
        featureId: 'Note1',
        category: 'Notifications',
        description: 'All alerts generated in the day categorised as per type',
        representation: 'Table',
        configFor: 'D',
        configProp: 'Base',
        enabled: true,
        rId: '#406:2',
        order: 0
      }
    ];
    t.dailyReConfigs = [];
    t.monthlyReConfigs = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].configFor === 'D') {
        t.dailyReConfigs.push(data[i]);
        t.origDailyReportConfigs.push(Object.assign({}, data[i]));
      } else {
        t.monthlyReConfigs.push(data[i]);
        t.origMonthlyReportConfigs.push(Object.assign({}, data[i]));
      }
    }

    t.monthlyReportConfigs = new MatTableDataSource<ReportConfig>(
      t.monthlyReConfigs
    );
    t.monthlyReportConfigs.paginator = t.paginatorMonthly;

    t.dailyReportConfigs = new MatTableDataSource<ReportConfig>(
      t.dailyReConfigs
    );
    t.dailyReportConfigs.paginator = t.paginatorDaily;
  }
  getReports() {
    const t = this;
    this.siteService
      .getAllReportConfigBySiteId(this.siteId)
      .subscribe((data) => {
        if (data.length > 0) {
          t.dailyReConfigs = [];
          t.monthlyReConfigs = [];
          for (let i = 0; i < data.length; i++) {
            if (data[i].configFor === 'D') {
              t.dailyReConfigs.push(data[i]);
              // t.origDailyReportConfigs.push(Object.assign({}, data[i]));
            } else {
              t.monthlyReConfigs.push(data[i]);
              // t.origMonthlyReportConfigs.push(Object.assign({}, data[i]));
            }
          }
          t.origDailyReportConfigs = cloneDeep(t.dailyReConfigs);
          t.origMonthlyReportConfigs = cloneDeep(t.monthlyReConfigs);
          t.monthlyReportConfigs = new MatTableDataSource<ReportConfig>(
            t.monthlyReConfigs
          );
          t.monthlyReportConfigs.paginator = t.paginatorMonthly;

          t.dailyReportConfigs = new MatTableDataSource<ReportConfig>(
            t.dailyReConfigs
          );
          t.dailyReportConfigs.paginator = t.paginatorDaily;
        }
      });
  }
  public previousStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(SiteStepperEnum.WidgetConfiguration, this.siteModel)
    );
  };
  nextStep = (event: any) => {
    event.preventDefault();
    this.siteStepperService.setSendStepper(true);
    this.siteStepperService.sendStepperSubject(
      new SiteStepperModel(
        SiteStepperEnum.DataAcquisitionLayout,
        this.siteModel
      )
    );
  };
  saveActivationsChanges(reportType) {
    const t = this;
    let dataForSaving = [];
    if (reportType === 'D') {
      dataForSaving = t.dailyReConfigs;
    } else {
      dataForSaving = t.monthlyReConfigs;
    }
    t.siteService
      .saveReportConfig(dataForSaving, t.siteId)
      .subscribe((data) => {
        if (data === true) {
          if (reportType === 'D') {
            // this.origDailyReportConfigs = [];
            this.origDailyReportConfigs = cloneDeep(this.dailyReConfigs);
            // this.dailyReConfigs.forEach(re => {
            //   this.origDailyReportConfigs.push(Object.assign({}, re));
            // });
          } else {
            this.origMonthlyReportConfigs = cloneDeep(this.monthlyReConfigs);
            // this.origMonthlyReportConfigs = [];
            // this.monthlyReConfigs.forEach(re => {
            //   this.origMonthlyReportConfigs.push(Object.assign({}, re));
            // });
          }
          this.alertService.showSuccess(Constants.MESSAGE.Save_success);
        } else {
          this.alertService.showError(Constants.MESSAGE.Save_failure);
        }
      });
  }
  cancel(reportType) {
    if (reportType === 'D') {
      // this.dailyReConfigs = [];
      // this.origDailyReportConfigs.forEach(re => {
      //   this.dailyReConfigs.push(Object.assign({}, re));
      // });
      // this.dailyReportConfigs = new MatTableDataSource<ReportConfig>(this.dailyReConfigs);
      // this.dailyReportConfigs.paginator = this.paginatorDaily;
      this.dailyReportConfigs.data = cloneDeep(this.origDailyReportConfigs);
    } else {
      // this.monthlyReConfigs = [];
      // this.origMonthlyReportConfigs.forEach(re => {
      //   this.monthlyReConfigs.push(Object.assign({}, re));
      // });
      // this.monthlyReportConfigs = new MatTableDataSource<ReportConfig>(this.monthlyReConfigs);
      // this.monthlyReportConfigs.paginator = this.paginatorMonthly;
      this.monthlyReportConfigs.data = cloneDeep(this.origMonthlyReportConfigs);
    }
  }

  restoreDefault(reportType) {
    const t = this;
    t.siteService.restoreDefault(t.siteId, reportType).subscribe((data) => {
      if (reportType === 'D') {
        // t.origDailyReportConfigs = Object.assign([], data);
        // t.dailyReConfigs = data;
        this.dailyReportConfigs = new MatTableDataSource<ReportConfig>(
          this.origDailyReportConfigs
        );
        this.dailyReportConfigs.paginator = this.paginatorDaily;
      } else {
        // t.origMonthlyReportConfigs = Object.assign([], data);
        // t.monthlyReConfigs = data;
        this.monthlyReportConfigs = new MatTableDataSource<ReportConfig>(
          this.origMonthlyReportConfigs
        );
        this.monthlyReportConfigs.paginator = this.paginatorMonthly;
      }

      this.alertService.showSuccess('Restore successfully!');
    });
  }
}
